import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { logout } from '../../../userData/store/actions';
import config from '../../../config';

class LogoutPage extends PureComponent {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    isLoggingOut: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    this.props.logout()
      .then(() => {
        window.open(`${config.BASE_PATH}${config.AUTH.SIGN_OUT_URL}`, config.AUTH.WINDOW_NAME);
      });
  }

  render() {
    if (this.props.isLoggingOut) {
      return null;
    }

    return (
      <div className="logout-page page-without-secondary-menu page-content-container">
        <div className="logout-page__text">
          <div>You have been logged out of this application.</div>
          <div>You may close the browser window, or <Link to="/">click here to log back in</Link>.</div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  isLoggingOut: state.user.isLoggingOut,
}), {
  logout,
})(LogoutPage);
